import { INITIAL_PAYMENT_RATE } from '../../../constants/newbuildingMortgage';

export const getInitialFirstPayment = (price: number): number => {
  return Math.round(price * INITIAL_PAYMENT_RATE);
};
